import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LangProvider } from "./context/LangContext";
import { ContentProvider } from "./context/ContentContext";
import { Layout } from "./components/Layout";
import { langFromPath } from "./lib/site";

import Landing from "./pages/Landing";
import InnerService from "./pages/InnerService";
import Guia from "./pages/Guia";
import Historia from "./pages/Historia";
import Legado from "./pages/Legado";
import Privacidade from "./pages/Privacidade";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

const M = (page) => <Layout>{page}</Layout>;

const TOAST_OPTIONS = { style: { background: "#161920", border: "1px solid rgba(212,175,55,0.3)", color: "#F5EFE6" } };

function AutoLang() {
  const navigate = useNavigate();
  const location = useLocation();
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (location.pathname !== "/") return;
    const stored = localStorage.getItem("mjn_lang");
    if (stored === "en") { navigate("/en", { replace: true }); return; }
    if (!stored) {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      const ptTz = tz === "Atlantic/Madeira" || tz === "Europe/Lisbon";
      const ptLang = (navigator.language || "").toLowerCase().startsWith("pt");
      if (!ptTz && !ptLang) navigate("/en", { replace: true });
    }
  }, [location.pathname, navigate]);
  return null;
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    localStorage.setItem("mjn_lang", langFromPath(pathname));
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
      <Routes location={location}>
        <Route path="/" element={M(<Landing />)} />
        <Route path="/en" element={M(<Landing />)} />
        <Route path="/consulta-online" element={M(<InnerService pageKey="consulta" dataKey="consulta" />)} />
        <Route path="/en/online-consultation" element={M(<InnerService pageKey="consulta" dataKey="consulta" />)} />
        <Route path="/direito-familia-internacional" element={M(<InnerService pageKey="internacional" dataKey="internacional" />)} />
        <Route path="/en/international-family-law" element={M(<InnerService pageKey="internacional" dataKey="internacional" />)} />
        <Route path="/vistos" element={M(<InnerService pageKey="vistos" dataKey="vistos" />)} />
        <Route path="/en/visas" element={M(<InnerService pageKey="vistos" dataKey="vistos" />)} />
        <Route path="/divorcio" element={M(<InnerService pageKey="divorcio" dataKey="divorcio" />)} />
        <Route path="/en/divorce" element={M(<InnerService pageKey="divorcio" dataKey="divorcio" />)} />
        <Route path="/pensoes-alimentos" element={M(<InnerService pageKey="alimentos" dataKey="alimentos" />)} />
        <Route path="/en/child-support" element={M(<InnerService pageKey="alimentos" dataKey="alimentos" />)} />
        <Route path="/patrimonio" element={M(<InnerService pageKey="patrimonio" dataKey="patrimonio" />)} />
        <Route path="/en/cohabitation-assets" element={M(<InnerService pageKey="patrimonio" dataKey="patrimonio" />)} />
        <Route path="/a-minha-historia" element={M(<Historia />)} />
        <Route path="/en/my-story" element={M(<Historia />)} />
        <Route path="/legado" element={M(<Legado />)} />
        <Route path="/en/legacy" element={M(<Legado />)} />
        <Route path="/guia" element={M(<Guia />)} />
        <Route path="/en/guide" element={M(<Guia />)} />
        <Route path="/privacidade" element={M(<Privacidade />)} />
        <Route path="/en/privacy" element={M(<Privacidade />)} />
        <Route path="/mjn-console" element={<Admin />} />
        <Route path="*" element={M(<NotFound />)} />
      </Routes>
  );
}

function App() {
  return (
    <LangProvider>
      <ContentProvider>
        <AutoLang />
        <ScrollManager />
        <AnimatedRoutes />
        <Toaster theme="dark" position="bottom-right" toastOptions={TOAST_OPTIONS} />
      </ContentProvider>
    </LangProvider>
  );
}

export default function Root() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
